/**
 * Created by andrey on 11.08.2025
 */

cc.ACTION_TAG_INVALID = -1;

cc.Action = function () {
    this.originalTarget = null;
    this.target = null;
    this.tag = cc.ACTION_TAG_INVALID;
    this._finalize = undefined;
};

cc.Action.prototype = Object.assign(Object.create(Object.prototype), {
    constructor: cc.Action,

    canFinalize: function () {
        return true;
    },

    setFinalize: function (finalizeFunc) {
        this._finalize = finalizeFunc;
        return this;
    },

    finalize: function (autoFinalize) {
        if (autoFinalize) {
            this._autoFinalize();
        }
        if (this._finalize) {
            this._finalize();
        }
    },

    _autoFinalize: function () {},

    /**
     * return true if the action has finished.
     *
     * @return {Boolean}
     */
    isDone: function () {
        return true;
    },

    /**
     * called before the action start. It will also set the target.
     *
     * @param {cc.Node} target
     */
    startWithTarget: function (target) {
        this.originalTarget = target;
        this.target = target;
    },

    /**
     * called after the action has finished. It will set the 'target' to nil. <br />
     * IMPORTANT: You should never call "action stop" manually. Instead, use: "target.stopAction(action);"
     */
    stop: function () {
        this.target = null;
    },

    /**
     * called every frame with it's delta time. <br />
     * DON'T override unless you know what you are doing.
     *
     * @param {Number} dt
     */
    step: function () {
        console.warn("[Action step]. override me", this.constructor);
    },

    /**
     * Called once per frame. Time is the number of seconds of a frame interval.
     *
     * @param {Number}  dt
     */
    update: function () {
        console.warn("[Action update]. override me", this.constructor);
    },

    /**
     * get the target.
     *
     * @return {cc.Node}
     */
    getTarget: function () {
        return this.target;
    },

    /**
     * The action will modify the target properties.
     *
     * @param {cc.Node} target
     */
    setTarget: function (target) {
        this.target = target;
    },

    /**
     * get the original target.
     *
     * @return {cc.Node}
     */
    getOriginalTarget: function () {
        return this.originalTarget;
    },

    /**
     * Set the original target, since target can be nil. <br/>
     * Is the target that were used to run the action.  <br/>
     * Unless you are doing something complex, like cc.ActionManager, you should NOT call this method. <br/>
     * The target is 'assigned', it is not 'retained'. <br/>
     * @param {cc.Node} originalTarget
     */
    setOriginalTarget: function (originalTarget) {
        this.originalTarget = originalTarget;
    },

    getTag: function () {
        return this.tag;
    },

    setTag: function (tag) {
        this.tag = tag;
    }
});

cc.action = () => new cc.Action();
